import React from 'react';
import { Select, SelectItem, IndexPath } from '@ui-kitten/components';
export const DNASelect = (props) => <Select {...props}/>;
DNASelect.Item = SelectItem;
DNASelect.Index = IndexPath;
export default DNASelect;
//# sourceMappingURL=DNASelect.js.map